import BookingPage from './BookingPage';

export default BookingPage;
